import type { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { OrderStatus } from "@/lib/api/types";

export const ORDER_STATUS_VALUES: OrderStatus[] = [
  "draft",
  "paid_less_than_required",
  "pending_buyer_verification",
  "pending_buyer_payment",
  "pending_payment_verification",
  "pending_seller_confirmation",
  "confirmed",
  "preparing",
  "shipped",
  "delivered",
  "cancelled",
  "declined",
];

export const ORDER_EDITABLE_STATUS_VALUES: OrderStatus[] = [
  "paid_less_than_required",
  "pending_buyer_verification",
  "pending_buyer_payment",
  "pending_payment_verification",
  "pending_seller_confirmation",
  "confirmed",
  "preparing",
  "shipped",
  "delivered",
  "declined",
  "cancelled",
];

export type QueueBucket =
  | "all"
  | "needsAction"
  | "inProgress"
  | "completed"
  | "cancelled"
  | "drafts"
  | "confirmed"
  | "preparing"
  | "shipped"
  | "delivered";

export function isEtaRelevantStatus(status: OrderStatus): boolean {
  return status === "confirmed" || status === "preparing" || status === "shipped";
}

export function getOrderStatusLabel(
  t: ReturnType<typeof useTranslations>,
  status: OrderStatus,
): string {
  if (status === "draft") {
    return t(keys.orders.statusCheckoutStarted);
  }
  const key =
    keys.buyer.orderStatusMap[status as keyof typeof keys.buyer.orderStatusMap] ??
    keys.buyer.orderStatusFallback;
  return t(key);
}
